export default __webpack_public_path__ + "static/media/commision.766feac7.svg";